import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import ProductPane from '../../../containers/products/ProviderProductInfoDetail'
import ProductEditPane from '../../../containers/products/ProviderProductInfoEdit'

const ProductPaneWrapper = (props: RouteComponentProps<any>) => {
  const { productId } = props.match.params
  return <ProductPane productId={productId} {...props} />
}

const ProductEditPaneWrapper = (props: RouteComponentProps<any>) => {
  const { productId } = props.match.params
  return <ProductEditPane productId={productId} {...props} />
}

const ProductDetailPanPage = (props: RouteComponentProps<any>) => {
  return (
    <div className='ProductDetail'>
      <Switch>
        <Route path={`${props.match.path}/edit`} component={ProductEditPaneWrapper} />
        <Route path={`${props.match.path}`} component={ProductPaneWrapper} />
      </Switch>
    </div>
  )
}

export default ProductDetailPanPage



// WEBPACK FOOTER //
// ./src/components/products/details/ProductPanePage.tsx